import { Stack } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { TypeUtils } from '../../../../framework/utils/UtilityTypes';
import StyledButton from '../../../components/StyledButton';
import { pageNames, pagePaths } from '../../../constants/Page';
import { useGlobalStateMachine } from '../../../GlobalStore';
import { useEngeneNavigate } from '../../../hooks/navigate';
import { usePostDeadlineSearch } from '../../../hooks/queries/deadline';
import { DeadlineMode } from '../../../models/gen/deadlineMode';
import DeadlineUtils from '../../../utils/DeadlineUtils';
import { useMasterContext } from '../../MasterProvider';
import Wireframe from '../../wireframe/Wireframe';

/**
 * 月次申請画面
 *
 * @returns
 */
const MonthlyOperation: React.FunctionComponent = () => {
  const { state } = useGlobalStateMachine();
  if (TypeUtils.isNil(state.userInfo)) {
    return <Navigate to={pagePaths.ROOT} />;
  }

  const master = useMasterContext();
  const navigate = useEngeneNavigate();

  const { data, refetch } = usePostDeadlineSearch({
    modes: [DeadlineMode.Monthly],
  });

  React.useState(() => refetch());

  return (
    <Wireframe
      title={pageNames.MONTHLY_OPERATION}
      topMessages={data?.results?.filter(DeadlineUtils.isMonthly)}
    >
      <Stack
        columnGap={10}
        direction={{ base: 'column', md: 'row' }}
        flexWrap="wrap"
        justifyContent="space-around"
        rowGap={2}
        width="full"
      >
        <StyledButton
          hidden={
            !TypeUtils.isNil(master.role.representative) &&
            state.userInfo!.role_id.includes(master.role.representative?.id)
          }
          onClick={() => navigate(pagePaths.SHIFT_APPLICATION)}
        >
          シフト申請
        </StyledButton>
        <StyledButton
          hidden={state.userInfo.roleOptions.isOutsourcer}
          onClick={() => navigate(pagePaths.ATTENDANCE_REPORT)}
        >
          勤怠申請
        </StyledButton>
        <StyledButton onClick={() => navigate(pagePaths.EXPENSE_REIMBURSEMENT)}>
          交通費・経費申請
        </StyledButton>
        <StyledButton
          hidden={state.userInfo.roleOptions.isOutsourcer}
          onClick={() => navigate(pagePaths.PAYSLIP)}
        >
          給与確認
        </StyledButton>
        <StyledButton
          hidden={!state.userInfo.roleOptions.isOutsourcer}
          onClick={() => navigate(pagePaths.INVOICE)}
        >
          請求
        </StyledButton>
      </Stack>
    </Wireframe>
  );
};

export default MonthlyOperation;
